<template>
  <q-btn
    v-show="visible"
    round
    color="primary"
    icon="mdi-chevron-down"
    class="absolute"
    style="bottom: 50px; right: 30px; z-index: 9"
    data-testid="chat-rolar-final"
    @click="$emit('click')"
  >
    <q-tooltip>Ir para o final</q-tooltip>
  </q-btn>
</template>

<script>
export default {
  name: 'ScrollToBottomButton',
  data () {
    return {
      visible: false
    }
  },
  methods: {
    updateVisibility (props) {
      const currentIndex = props.index
      const lastIndex = props.to
      this.visible = lastIndex - currentIndex > 20
    },
    hide () {
      this.visible = false
    }
  }
}
</script>
